import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { LinkModule } from '../../chords/link/link.module';
import { ButtonModule } from '../button/button.module';
import { MobileActionsModalComponent } from './mobile-actions-modal.component';

@NgModule({
  declarations: [MobileActionsModalComponent],
  imports: [CommonModule, ButtonModule, LinkModule],
  exports: [MobileActionsModalComponent],
})
export class MobileActionsModalModule {}
